<template>
  <!--产值申报-->
  <div>
    <div class="cooperation-report-detail-container">
      <div class="report-title">
        <div class="left">
          <p>
            累计申报产值： <span>{{ body.adApplyamount | money2 }}</span>
          </p>
          <p>
            累计审定金额： <span>{{ body.adApproveamount | money2 }}</span>
          </p>
          <p>
            累计应付进度款： <span>{{ body.adScheduleamount | money2 }}</span>
          </p>
        </div>
        <div class="right">
          <p>
            本月申报金额：<span>{{ body.cmApplyamount | money2 }}</span>
          </p>
          <p>
            本月审定金额：<span>{{ body.cmApproveamount | money2 }}</span>
          </p>
          <p>
            本月应付进度款：<span>{{ body.cmScheduleamount | money2 }}</span>
          </p>
        </div>
      </div>
      <div class="report-list-content">
        <van-list
          :offset="30"
          v-model="loading"
          :finished="finished"
          :immediate-check="false"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <van-cell v-for="(item, index) in list" :key="index">
            <template>
              <report-list :item="item"></report-list>
            </template>
          </van-cell>
        </van-list>
      </div>
    </div>
  </div>
</template>

<script>
import reportList from './components/cooperation-report-detail-list';
import { Sticky, List, PullRefresh } from 'vant';
import { getUrlParams } from 'common/js/mUtils';

export default {
  name: 'cooperation-report-detail',

  data() {
    return {
      body: {},
      list: [],
      loading: true,
      finished: false,
      refreshing: false,
      current: 1,
      size: 10,
      contractguid: '',
      sticky: true
    };
  },

  mounted() {},
  created() {
    let { contractguid } = this.$route.query;
    let { id } = getUrlParams();
    if (!contractguid) {
      contractguid = id;
    }
    this._getApplyStatisticsByid(contractguid);
    let params = {
      contractguid: contractguid,
      current: this.current,
      size: this.size
    };
    this.contractguid = contractguid;
    this._getApplyInfoByid(params);
  },
  components: {
    reportList,
    [Sticky.name]: Sticky,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh
  },

  methods: {
    _getApplyStatisticsByid(contractguid) {
      this.$api.getApplyStatisticsByid({ contractguid }).then(res => {
        let { status, body } = res;
        if (status) {
          this.body = body;
        }
      });
    },
    _getApplyInfoByid(params) {
      let { current, contractguid, size } = this;
      params = { current, size, contractguid, ...params };
      this.$api.getApplyInfoByid(params).then(res => {
        let { status, body } = res;
        let { records } = body;
        if (status) {
          this.loading = false;
          this.refreshing = false;
          if (records.length == 0) {
            this.finished = true;
            return;
          }
          this.list = this.list.concat(records);
        }
      });
    },
    onLoad() {
      this.current++;
      this._getApplyInfoByid({});
    }
  }
};
</script>

<style scoped lang="scss">
.cooperation-report-detail-container {
  position: relative;
  // background: #f2f2f2;
  margin-top: 10px;
  z-index: 9;
  .report-list-content {
    margin-top: 10px;
    // background: white;
    /deep/ .van-cell {
      position: relative;
      display: flex;
      box-sizing: border-box;
      width: 100%;
      padding: 0px;
      overflow: hidden;
      color: #323233;
      font-size: 0.28rem;
      line-height: 1;
      background-color: transparent;
      margin-bottom: 10px;
    }
  }
  .report-title {
    // height: 180px;
    width: 100%;
    background: transparent;
    display: flex;
    padding: 30px;
    font-size: 24px;
    .left {
      width: 50%;
      // height: 130px;
      border-right: 1px solid #efefef;
      span {
        color: #000000;
      }
      p {
        margin-top: 15px;
        color: #666666;
      }
      p:nth-child(1) {
        margin-top: 0;
      }
    }
    .right {
      // height: 130px;
      width: 50%;
      padding-left: 20px;
      span {
        color: #c18858;
      }
      p {
        margin-top: 15px;
      }
      p:nth-child(1) {
        margin-top: 0;
      }
    }
  }
}
</style>
<style lang="scss">
.cooperation-report-detail-container {
}
</style>
